import { render } from "./Home.vue?vue&type=template&id=4fe30160"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=4fe30160&lang=css"
script.render = render

export default script